<div class="main">
  <emt-navbar [hidden]="isReportOpened"></emt-navbar>
  <emt-side-nav [hidden]="isReportOpened"></emt-side-nav>
  <emt-layout class="app-layout"></emt-layout>
</div>
